import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { BaseCellComponent } from '../base-cell.component';

/**
 * Ячейка с типом данных дата и время (ISO/SQL формат)
 */
@Component({
    selector: 'app-datetime-cell',
    template: ' {{ getFormattedValue() }}',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DatetimeCellComponent extends BaseCellComponent {
    private readonly datePipe = inject(DatePipe);

    /**
     * SQL/ISO формат даты с опциональным временем и миллисекундами
     */
    private readonly regex = new RegExp(/^\d{4}-\d{2}-\d{2}(?: [0-2]\d:[0-5]\d(?::[0-5]\d(?:\.\d{1,3})?)?)?$/);

    /**
     * Получить отформатированное значение
     */
    protected getFormattedValue() {
        const rawValue = this.row[this.alias];
        if (rawValue === undefined || rawValue === null) {
            return '';
        }

        try {
            if (!this.regex.test(rawValue)) {
                return rawValue;
            }
            switch (this.column.type) {
                case 'date':
                    return this.datePipe.transform(rawValue, 'shortDate');
                case 'datetime':
                    return (
                        this.datePipe.transform(rawValue, 'shortDate') +
                        ' ' +
                        this.datePipe.transform(rawValue, 'mediumTime')
                    );
                default:
                    return rawValue;
            }
        } catch {
            return rawValue;
        }
    }
}
